import { Controller } from "@hotwired/stimulus";

import { jobs } from "~/api";

// Connects to data-controller="job"
export default class extends Controller {
  execute({ target }) {
    this.processResponse(jobs.execute(this.requestArgs(target)));
  }

  toggle({ target }) {
    const enabled = target.checked;
    const args = this.requestArgs(target);

    this.processResponse(jobs.toggle({ ...args, data: { enabled } }));
  }

  requestArgs(target) {
    const jobId = target.getAttribute("data-jobid");

    return {
      params: { id: jobId },
      responseAs: "response",
      headers: { Accept: "text/html" }
    };
  }

  processResponse(promise) {
    promise
      .then((response) => response.text())
      .then((html) => {
        const header = document.getElementById("header");
        header.insertAdjacentHTML("afterend", html);

        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      })
      .catch((error) => console.warn(error));
  }
}
